import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import PageValidatePhone from "../PageValidatePhone";
import PageVerificationCode from "../PageVerificationCode";
import PageFaceCaptureInstructions from "../PageFaceCaptureInstructions";
import PageFaceCapture from "../PageFaceCapture";
import PageVerifyIdentity from "../PageVerifyIdentity";
import PageThankYou from "../PageThankYou";
import PageApproved from "../PageApproved";
import PageDeclined from "../PageDeclined";
import PageReviewing from "../PageReviewing";
import PageLivenessTest from "../PageLivenessTest";
import PageLivenessTestRetry from "../PageLivenessTestRetry";
import PageDocumentCapturePortrait from "../PageDocumentCapturePortrait";
// import PageDocumentCaptureLandscape from "../PageDocumentCaptureLandscape";
// import PageDocumentCaptureLock from "../PageDocumentCaptureLocked";
import PageDocumentCaptureInstructions from "../PageDocumentCaptureInstructions";
import PageDocumentCaptureConfirm from "../PageDocumentCaptureConfirm";
import PageFaceCaptureConfirm from "../PageFaceCaptureConfirm";
import DebugLinks from "../DebugLinks";
import PageSentToMobile from "../PageSentToMobile";
import PageFaceLiveness3D from "../PageFaceLiveness3D";
import PageInstructionsFaceLiveness3D from "../PageInstructionsFaceLiveness3D";
import PageGDPR from "../PageGDPR";
import PageInstructionsCLR from "../PageInstructionsCLR";
import PageInstructionVideo3DFL from "../PageInstructionVideo3DFL";
import PageInstructionVideoDocument from "../PageInstructionVideoDocument";
import PageInstructionVideoSelfie from "../PageInstructionVideoSelfie";
import PageDocumentCountrySelector from "../PageDocumentCountrySelector";
import PageIntroScreen from "../PageIntroScreen";
import { logEvent, PAGE_OPEN } from "../../logic/eventLogger";

const pages = {
  PageGDPR: <PageGDPR />,
  PageValidatePhone: <PageValidatePhone />,
  PageVerificationCode: <PageVerificationCode />,
  PageFaceCaptureInstructions: <PageFaceCaptureInstructions />,
  PageFaceCapture: <PageFaceCapture />,
  PageFaceCaptureConfirm: <PageFaceCaptureConfirm />,
  PageVerifyIdentity: <PageVerifyIdentity />,
  PageThankYou: <PageThankYou />,
  PageApproved: <PageApproved />,
  PageDeclined: <PageDeclined />,
  PageReviewing: <PageReviewing />,
  PageLivenessTest: <PageLivenessTest />,
  PageLivenessTestRetry: <PageLivenessTestRetry />,
  PageDocumentCapturePortrait: <PageDocumentCapturePortrait />,
  // PageDocumentCaptureLandscape: <PageDocumentCaptureLandscape />,
  // PageDocumentCaptureLock: <PageDocumentCaptureLock />,
  PageDocumentCaptureInstructions: <PageDocumentCaptureInstructions />,
  PageInstructionVideoDocument: <PageInstructionVideoDocument />,
  PageDocumentCaptureConfirm: <PageDocumentCaptureConfirm />,
  PageSentToMobile: <PageSentToMobile />,
  PageFaceLiveness3D: <PageFaceLiveness3D />,
  PageInstructionsFaceLiveness3D: <PageInstructionsFaceLiveness3D />,
  PageInstructionVideoSelfie: <PageInstructionVideoSelfie />,
  PageInstructionVideo3DFL: <PageInstructionVideo3DFL />,
  PageInstructionsCLR: <PageInstructionsCLR />,
  PageDocumentCountrySelector: <PageDocumentCountrySelector />,
  PageIntroScreen: <PageIntroScreen />,
};

export default function Navigation() {
  const page = useSelector((state) => state.navigation.page);
  const featureFlags = useSelector(
    (state) => state.configuration.extraConfig.featureFlags
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  const isDebugLinksActive =
    featureFlags.debugLinks === "true" || process.env.REACT_APP_DEBUG_LINKS;

  if (page) {
    logEvent(PAGE_OPEN, { name: page });
    logEvent(PAGE_OPEN + "_" + page.toLowerCase());
  }
  return (
    <React.Fragment>
      {pages[page]}
      {isDebugLinksActive && (
        <DebugLinks
          pages={{
            PageIntroScreen: <PageIntroScreen />,
            PageGDPR: <PageGDPR />,
            PageValidatePhone: <PageValidatePhone />,
            PageFaceCapture: <PageFaceCapture />,
            PageVerifyIdentity: <PageVerifyIdentity />,
            PageInstructionsFaceLiveness3D: <PageInstructionsFaceLiveness3D />,
            PageInstructionsCLR: <PageInstructionsCLR />,
            PageDocumentCountrySelector: <PageDocumentCountrySelector />,
          }}
        />
      )}
    </React.Fragment>
  );
}
